import { Box } from "@qws-org/ui-kit";
import type { FC } from "react";
import { tv } from "tailwind-variants";

type BurgerMenuProps = {
  onBurgerMenuClick: () => void;
  isBurgerMenuOpen: boolean;
};

const burgerButton = tv({
  variants: {
    open: {
      true: "rotate-45",
    },
  },
});

const burgerLine = tv({
  base: "transition-all duration-300  ",
  variants: {
    index: {
      0: "  delay-300",
      1: " ",
      2: " ",
      3: "  delay-300",
    },
    open: {
      true: "",
      false: "",
    },
  },
  compoundVariants: [
    {
      index: 0,
      open: true,
      class: " transition-none",
    },
    {
      index: 2,
      open: true,
      class: " transform rotate-90",
    },
    {
      index: 3,
      open: true,
      class: " transition-none",
    },
  ],
});

export const BurgerMenu: FC<BurgerMenuProps> = ({
  onBurgerMenuClick,
  isBurgerMenuOpen,
}) => {
  return (
    <Box
      onClick={onBurgerMenuClick}
      width={28}
      height={20}
      m={{
        ml: 16,
        mb: isBurgerMenuOpen ? "auto" : 6,
        mr: 24,
        mt: isBurgerMenuOpen ? -4 : 0,
      }}
      maxWidth="fit-content"
      minWidth="fit-content"
      d={{ display: "hidden" }}
      position={{ type: isBurgerMenuOpen ? undefined : "relative" }}
      className={burgerButton({
        open: isBurgerMenuOpen,
        className: "  cursor-pointer transition-all duration-300 ease-linear ",
      })}
      data-testid="header-burger"
    >
      <Box
        m={{ mt: 4 }}
        as="span"
        width={24}
        height={2}
        bg="surface-secondary-default"
        className={burgerLine({ index: 0, open: isBurgerMenuOpen })}
        position={{ type: "absolute", left: 0, top: 0 }}
        opacity={isBurgerMenuOpen ? 0 : 100}
      />
      <Box
        m={{ mt: 4 }}
        as="span"
        width={24}
        height={2}
        bg="surface-secondary-default"
        className={burgerLine({ index: 1, open: isBurgerMenuOpen })}
        position={{ type: "absolute", left: 0, top: 9 }}
      />
      <Box
        m={{ mt: 4 }}
        as="span"
        width={24}
        height={2}
        bg="surface-secondary-default"
        className={burgerLine({ index: 2, open: isBurgerMenuOpen })}
        position={{ type: "absolute", left: 0, top: 9 }}
        opacity={100}
      />
      <Box
        m={{ mt: 4 }}
        as="span"
        width={24}
        height={2}
        bg="surface-secondary-default"
        className={burgerLine({ index: 3, open: isBurgerMenuOpen })}
        position={{ type: "absolute", left: 0, top: 18 }}
        opacity={isBurgerMenuOpen ? 0 : 100}
      />
    </Box>
  );
};
